import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=604dd1ec"
import script from "./SidebarLink.vue?vue&type=script&lang=js"
export * from "./SidebarLink.vue?vue&type=script&lang=js"
import style0 from "./SidebarLink.vue?vue&type=style&index=0&id=604dd1ec&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('604dd1ec')) {
      api.createRecord('604dd1ec', component.options)
    } else {
      api.reload('604dd1ec', component.options)
    }
    module.hot.accept("./SidebarLink.vue?vue&type=template&id=604dd1ec", function () {
      api.rerender('604dd1ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/app-sidebar/components/SidebarLink.vue"
export default component.exports